export default function BatteryHudIsCharging() {
    return (
        <div className="battery-charging-icon">
        <svg width="8.829" height="17.657" viewBox="0 0 8.829 17.657">
            <path id="Icon_material-battery-charging-full" data-name="Icon material-battery-charging-full" d="M18.154,4.766H16.68V3H13.149V4.766H11.674A1.179,1.179,0,0,0,10.5,5.94V19.474a1.181,1.181,0,0,0,1.174,1.183h6.471a1.181,1.181,0,0,0,1.183-1.174V5.94A1.179,1.179,0,0,0,18.154,4.766ZM14.031,18.892V14.036H12.266L15.8,7.414V12.27h1.766Z" transform="translate(-10.5 -3)" fill="#e55213"/>
        </svg>
        </div>
    )
}